var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4H11V18C11 19.1046 10.1046 20 9 20H4V6C4 4.89543 4.89543 4 6 4ZM15 4H20V18C20 19.1046 19.1046 20 18 20H13V6C13 4.89543 13.8954 4 15 4Z",
    fill: "#9A9CB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoColumn);
export default __webpack_public_path__ + "static/media/ico-column.a0902ed4b1574b7635a3293f3df5caf8.svg";
export { ForwardRef as ReactComponent };